<div class="flex flex-col items-center justify-center gap-y-5 p-3">
  <!-- <ng-lottie class="w-[150px]" [options]="options"></ng-lottie -->
  <div #lottieContainer class="w-[150px] h-[150px]"></div>

  <p class="text-P whitespace-pre-line center">
    {{ config.data?.content?.[0] ?? "" }}
  </p>
</div>
